import { EnumBase } from 'hay-core-react';
class ClassificacaoTipoEnum extends EnumBase {
  constructor() {
    super(
      [
        'main.classificacaomonitoramentotemplate.tipo.indicador',
        'main.classificacaomonitoramentotemplate.tipo.templatecampo',
      ],
      'main.classificacaomonitoramentotemplate.tipo.indicador'
    );
  }
}

export default new ClassificacaoTipoEnum();
